/**
 * Export buttons for the Export component
 */

export const exportOptions = [{
  label: 'Sites',
  name: 'site',
}, {
  label: 'Visits',
  name: 'visit',
}, {
  label: 'Notes',
  name: 'note',
}, {
  label: 'Tags',
  name: 'tags',
}, {
  label: 'Seasons',
  name: 'seasons',
}, {
  label: 'Users',
  name: 'user',
}, {
  label: 'Contacts',
  name: 'contact',
}];
